/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_SystemInputs */

const cs_social_templates_system = /** @type {(inputs: Social_Templates_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systémová`)
};

const en_social_templates_system = /** @type {(inputs: Social_Templates_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Social_Templates_SystemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_system = /** @type {((inputs?: Social_Templates_SystemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_SystemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_system(inputs)
	return cs_social_templates_system(inputs)
});